var exports = {
  "th": "xaee3c4fa--f74833--th",
};

module.exports = exports;
